import React from "react"
import { Check } from "react-bootstrap-icons"
import styles from "./styles.module.scss"

const UploadingStatus = ({ imagePreview, index, onRemoveImage }) => {
  return imagePreview.isUploading ? (
    <>
      {typeof imagePreview.uploadProgress === "number" && (
        <>
          <div className={styles.uploadProgressText}>{imagePreview.uploadProgress}%</div>
          <div className={styles.uploadProgressTrack}>
            <div
              className={styles.uploadProgressBar}
              style={{ width: `${imagePreview.uploadProgress}%` }}
            />
          </div>
        </>
      )}
    </>
  ) : imagePreview.isUploaded ? (
    <Check className={styles.uploadedCheck} />
  ) : (
    <button
      className={styles.removeBtn}
      type="button"
      onClick={() => onRemoveImage(index)}
    >
      &times;
    </button>
  )
}

export default UploadingStatus
